import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

const ClosePopup = () => {

  //Helper function that converts window.location.hash into a dictionary
  const getHashParameters = () => {
    const hashParams: any = {};
    window.location.hash.substring(1).split("&").forEach((item) => {
      const [key, value] = item.split("=");
      hashParams[key] = decodeURIComponent(value);
    });
    return hashParams;
  };

  useEffect(() => {
    microsoftTeams.app.initialize();

    //The Azure implicit grant flow injects the result into the window.location.hash object. Parse it to find the results.
    const hashParams: any = getHashParameters();

    //If consent has been successfully granted, the access token should be present as a field in the dictionary.
    if (hashParams.access_token) {
      microsoftTeams.authentication.notifySuccess(hashParams.access_token);
    } else {
      microsoftTeams.authentication.notifyFailure("Consent failed");
    }
  }, []);

  return <h1>Consent flow complete</h1>;
};

export default ClosePopup;
